module.exports = __webpack_public_path__ + "static/media/Swiftnift.7d03b0c1.png";